import { render } from "./Edit.vue?vue&type=template&id=0777fa7b"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"
script.render = render

export default script